export default __webpack_public_path__ + "static/media/heartIconRed.ee3bef24.svg";